// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__dQdTl","icon":"StyledButton_icon__3vbY2","text":"StyledButton_text__2rY-l"};